<template>
    <div class="TopLogoBar" :class="{fixedPosition: isFixed}">
        <div class="logoContainer">
            <a @click="logoClick">
                <img src="@/assets/images/logoBlack.png" alt="page93 s.r.l." v-if="logoColor != 'white' && logoSpecial == null" />
                <img src="@/assets/images/logoWhite.png" alt="page93 s.r.l." v-if="logoColor == 'white' && logoSpecial == null" />
                <img src="@/assets/images/page/blackSoftware.png" alt="page93 s.r.l." v-if="logoSpecial == 'software'" />
                <img src="@/assets/images/page/blackService.png" alt="page93 s.r.l." v-if="logoSpecial == 'service'" />
                <img src="@/assets/images/page/blackHardware.png" alt="page93 s.r.l." v-if="logoSpecial == 'hardware'" />
                <img src="@/assets/images/page/black93.png" alt="page93 s.r.l." v-if="logoSpecial == '93'" />
                <img src="@/assets/images/page/blackPage.png" alt="page93 s.r.l." v-if="logoSpecial == 'page'" />
            </a>
        </div>
        <div class="titleContainer" :style="{color: textColor}">
            <h2>{{ title }}</h2>
            <h5>{{ subtitle }}</h5>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopLogoBar',
        props: [
            'logoColor',
            'title',
            'textColor',
            'subtitle',
            'isInHome',
            'logoSpecial',
            'isFixed'
        ],
        methods: {
            logoClick()
            {
                if(this.isInHome)
                {
                    this.$scrollTo("#home")
                    return;
                }

                this.$router.push('/')
            }
        }
    }
</script>

<style scoped lang="scss">
    .TopLogoBar {
        height: 200px;
        width: 100%;

        display: flex;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        padding-bottom: 20px;
        justify-content: center;

        &.fixedPosition
        {
            position: fixed;
            top: 0;
            left: 0;
        }

        .logoContainer {
            display: flex;
            justify-content: center;
            align-items: center;

            a {
                width: 100%;
                height: 100%;
            }

            img {

                height: 100%;
                width: 100%;
                object-fit: contain;
            }
        }

        .titleContainer {
            flex-grow: 1;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            padding-left: 20px;
            padding-right: 20px;
            flex-wrap: wrap;
            overflow: hidden;

            h2 {
                text-transform: uppercase;
                font-weight: 900;
                font-size: 22px;
                margin-top: 85px;
            }

            h5 {
                font-weight: 500;
                font-size: 20px;
            }

            @media only screen and (max-width: 768px) {
                justify-content: center;

                h2 {
                    margin-top: 0;

                }
            }
        }
    }
</style>